<div class="flex h-screen bg-gray-50 transition-colors duration-300">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Contenedor principal -->
  <div class="flex-1 flex flex-col">
    <!-- Navbar superior -->
    <app-navbar></app-navbar>


  </div>
</div>
